import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import WebsiteTypesSection from "../components/WebsiteTypesSection";
import MarketingSection from "../components/MarketingSection";
import PrintSection from "../components/PrintSection";
import StatsSection from "../components/StatsSection";
import SeoMeta from "../components/SeoMeta";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  url: "https://devtechpro.fr",
  name: "Dev-Tech",
  description:
    "Dev-Tech propose des solutions digitales innovantes pour les entreprises : développement web, applications React, et consulting technique.",
  logo: "https://devtechpro.fr/logo-og.png",
  sameAs: [
    "https://www.linkedin.com/company/dev-tech",
    "https://www.instagram.com/dev-tech",
    "https://www.facebook.com/dev-tech"
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+33 7 58 13 24 06",
      contactType: "customer support",
      areaServed: "FR",
      availableLanguage: ["Français", "English"]
    }
  ]
};

export default function Home() {
  return (
    <main className="home-container">
      <SeoMeta
        title="Agence digitale complète"
        description="Stratégies web, React, marketing et design sur mesure pour faire décoller votre entreprise."
        canonical="https://devtechpro.fr/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ServicesSection />
      <WebsiteTypesSection />
      <MarketingSection />
      <PrintSection />
      <StatsSection />
    </main>
  );
}